//---------------------imports-------------------------
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import { Itemdata } from "../../assets/Griddata";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { externalgetApi } from "../../services/external/externalApis";
import { SETTINGS_API_03, COMMON_API_02 } from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_STATUS_KITCHEN,
} from "../../utils/sys/Constants";
import {
  currencyFormat,
  currencyFormatLKR,
} from "../../../src/utils/common/CurrencyFormat";
import CircularProgress from "@mui/material/CircularProgress";

import { CHAINCODE } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import SearchAppBar from "../../components/common/search";

function ViewAddItem() {
  //-------------------hooks---------------------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(COMMON_API_02, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,

          STS: CON_STATUS_ACTIVE,
          STSK: CON_STATUS_KITCHEN,
          // MENUCATCODE
        });
        setData(result);
        setFilteredData(result);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);
  const mapResultToRows = (result) => {
    return result.map((item) => ({
      id: item.MENUCODE,
      MENUNAME: item.MENUNAME,
      MENUCODE: item.MENUCODE,
      DISCOUNT: currencyFormatLKR(item.DISCOUNT, "LKR", false),
      RATE: currencyFormatLKR(item.RATE, "LKR", false),
      ISTAXAPPLY: item.ISTAXAPPLY,
      MEASURINGUNIT: String(item.MEASURINGUNIT),
      ITEMEATE: String(item.ITEMEATE),
    }));
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        const menudCodeString = String(item.MENUCODE);
        return (
          menudCodeString.toLowerCase().includes(searchText.toLowerCase()) ||
          item.MENUNAME.toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  //------------------------------functions-----------------------------------
  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const gotToAddItems = () => {
    navigate("/AddItem");
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.MENUCODE === id);
      if (selectedItem) {
        const stringifiedItem = Object.fromEntries(
          Object.entries(selectedItem).map(([key, value]) => [
            key,
            String(value),
          ])
        );

        navigate(`/AddItem`, {
          state: { selectedItem: stringifiedItem, actionText },
        });
      }
    } else {
      navigate(`/AddItem`, { state: { selectedItem: "" } });
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (MENUCODE) => handleItemClick(MENUCODE, "Edit"),
    },
  ];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Setting</Link>
                <Link underline="none">Add Items</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={gotToAddItems}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box id="back-to-top-anchor">
        {isLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="60vh"
          >
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <ViewData
            columns={Itemdata.columns}
            rows={filteredData ? mapResultToRows(filteredData) : []}
            menuItems={menuItems}
            tabletitle={Itemdata.name}
            gridid="MENUCODE" // Ensure this matches the key you want to use
          />
        )}
      </Box>
    </div>
  );
}

export default ViewAddItem;
